import { render } from "./ReadingQuestionCard.vue?vue&type=template&id=53fb736d&scoped=true&lang=true"
import script from "./ReadingQuestionCard.vue?vue&type=script&lang=js"
export * from "./ReadingQuestionCard.vue?vue&type=script&lang=js"

import "./ReadingQuestionCard.vue?vue&type=style&index=0&id=53fb736d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fb736d"]])

export default __exports__